import React from "react";
import Quote from "./Quote";
import Introduction from "./Introduction";
import AboutMe from "./AboutMe";
import Skills from "./Skills";
import Experience from "./Experience";
import Projects from "./Projects";
import Text from "./Text";
import Footer from "./Footer";

const Home = () => {
  return (
    <main className="fade-in">
      <Quote />
      <Introduction />
      <AboutMe />
      <Skills />
      <Experience />
      <Projects />
      <Text />
      <Footer />
    </main>
  );
};

export default Home;
